'use strict';
var base = require('./base');
var focusHelper = require('base/components/focus');
var addToCartTooltip = require('./addToCartTooltip');
var colorSwatchTooltip = require('./colorSwatchTooltip');
var specialSelect = require('../components/specialSelect');
var utils = require('pagedesigner/util/utils');
var zoomConfigs = require('../config/zoomConfigs');

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('#quickViewModal').length !== 0) {
        $('#quickViewModal').remove();
    }
    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="quickViewModal" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog modal-dialog-centered quick-view-dialog modal--added-by-js">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <span class="quick-view-title"></span>'
        + '    <button type="button" class="close pull-right mt-0" data-dismiss="modal">'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}

/**
 * @typedef {Object} QuickViewHtml
 * @property {string} body - Main Quick View body
 * @property {string} footer - Quick View footer content
 */

/**
 * Parse HTML code in Ajax response
 *
 * @param {string} html - Rendered HTML from quickview template
 * @return {QuickViewHtml} - QuickView content components
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.product-quickview');
    var footer = $html.find('.modal-footer').children();
    var quickAddTitle = body.data('quick-add-title');

    return { body: body, footer: footer, quickAddTitle: quickAddTitle };
}

/**
 * replaces the content in the modal window on for the selected product variation.
 * @param {string} selectedValueUrl - url to be used to retrieve a new product model
 * @param {HTMLElement} initiatorEl - element that triggered the quickview
 */
function fillModalElement(selectedValueUrl, initiatorEl) {
    var $qvModal = $('#quickViewModal');
    var $modalContent = $qvModal.find('.modal-content');

    $modalContent.spinner().start();
    $qvModal.modal('show');

    $.ajax({
        url: selectedValueUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);

            $qvModal.find('.modal-body').empty().html(parsedHtml.body);
            $qvModal.find('.quick-view-title').text(parsedHtml.quickAddTitle);
            $qvModal.find('.full-pdp-link').text(data.quickViewFullDetailMsg).attr('href', data.productUrl);
            $qvModal.find('.size-chart').attr('href', data.productUrl);
            $qvModal.find('.modal-header .close .sr-only').text(data.closeButtonText);
            $qvModal.find('.enter-message').text(data.enterDialogMessage);
            var ratingClone = $('.rating-' + data.product.uuid + ' #yotpo-bottomline-top-div').clone();
            $qvModal.find('#yotpo-bottomline-top-div').empty().html(ratingClone[0]);
            $(document.body).triggerHandler('globale:updatePrices');
            $('body').trigger('quickview:ready', data);

            const widgetContainer = $(initiatorEl).closest('.recommends-container');
            if (initiatorEl && widgetContainer.length) {
                $qvModal.data('ref-widget-id', widgetContainer.data('widget-id'));
                $qvModal.data('ref-widget-type', widgetContainer.data('wty'));
            }

            addToCartTooltip.init();
            $modalContent.spinner().stop();
            colorSwatchTooltip.init();
            base.initSizeTooltips();
            specialSelect.init();
        },
        error: function () {
            $modalContent.spinner().stop();
            $qvModal.modal('hide');
        }
    });
}

/**
 * Enables switching product lengths inside the Quick View modal by AJAX-loading
 * a new Quick View for the selected length instead of navigating away.
 */
function bindLengthSwitchInQuickview() {
    $('body').on('click', '.js-quickview-length', function (e) {
        var $link = $(this);

        // If we’re NOT inside the quickview modal, let it behave like a normal PDP link
        if (!$link.closest('#quickViewModal').length) {
            return;
        }

        var url = $link.data('qv-href');
        if (!url) {
            // No quickview URL defined: fall back to normal navigation
            return;
        }

        e.preventDefault();

        // Reuse the same logic as the PLP quickview button
        fillModalElement(url);
    });
}

module.exports = {
    showQuickview: function () {
        $('body').off('click', '.quickview');
        $('body').on('click', '.quickview', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (Window.BrTrk) {
                try {
                    const title = this.getAttribute('title');
                    const dataHref = this.getAttribute('data-href');
                    const urlParams = new URLSearchParams(dataHref.split('?')[1]);
                    const pid = urlParams.get('pid');
                    var prodData = {};
                    prodData.prod_id = pid;
                    prodData.prod_name = title;
                    prodData.sku = '';
                    Window.BrTrk.getTracker().logEvent('product', 'quickview', prodData);
                } catch (error) {
                    console.log('Error while sending tracking data');
                }
            }
            var selectedValueUrl = $(this).closest('button.quickview').data('href');
            $(e.target).trigger('quickview:show');
            getModalHtmlElement();
            fillModalElement(selectedValueUrl, this);
        });
    },
    focusQuickview: function () {
        $('body').on('shown.bs.modal', '#quickViewModal', function () {
            $('#quickViewModal .close').focus();
        });
    },
    onClosingQuickview: function () {
        $('body').on('hidden.bs.modal', '#quickViewModal', function () {
            $('#quickViewModal').remove();
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open');
        });
    },
    trapQuickviewFocus: function () {
        $('body').on('keydown', '#quickViewModal', function (e) {
            var focusParams = {
                event: e,
                containerSelector: '#quickViewModal',
                firstElementSelector: '.full-pdp-link',
                lastElementSelector: '.add-to-cart-global',
                nextToLastElementSelector: '.modal-footer .quantity-select'
            };
            focusHelper.setTabNextFocus(focusParams);
        });
    },
    availability: base.availability,
    addToCart: base.addToCartQuickView,

    showSpinner: function () {
        $('body').on('product:beforeAddToCart', function (e, data) {
            $(data).closest('.modal-content').spinner().start();
        });
    },
    hideDialog: function () {
        $('body').on('product:afterAddToCart', function (e, data) {
            if (!data.error) {
                var $qvModal = $('#quickViewModal');
                $qvModal.addClass('modal--item-added');
                $qvModal.find('.modal-header').find('.quick-view-title').text(data.itemAddedTitle);
                $qvModal.find('.modal-body').addClass('invisible').hide(400, function () {
                    $(this).remove();
                });
                setTimeout(() => {
                    $qvModal.modal('hide');
                }, data.quickAddToCartPopupHideTimeout);
            }
        });
    },
    beforeUpdateAttribute: function () {
        $('body').on('product:beforeAttributeSelect', function () {
            $('.modal.show .modal-content').spinner().start();
        });
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            var upChargeTextArray = response.data.product.upChargeText;
            var upChargeText = '';
            for (var index = 0; index < upChargeTextArray.length; index++) {
                upChargeText += upChargeTextArray[index] + '\n';
            }
            var upChargeTextSelector = $('.modal.show .product-quickview').find('.size-extra-price');
            // control over the UpCharge text
            if (!response.data.product.hideUpChargeText) {
                if (response.data.product.isVariant) {
                    if (!upChargeTextSelector.hasClass('d-none')) {
                        upChargeTextSelector.addClass('d-none');
                    }
                } else {
                    if (upChargeTextSelector.hasClass('d-none')) { // eslint-disable-line
                        upChargeTextSelector.removeClass('d-none');
                    }
                }
            }
            if ($('.modal.show .product-quickview>.bundle-items').length) {
                $('.modal.show').find(response.container).data('pid', response.data.product.id);
                $('.modal.show').find(response.container)
                    .find('.product-id').text(response.data.product.id);
                $('.modal.show').find(response.container)
                    .find('.size-extra-price').text(upChargeText);
            } else if ($('.set-items').length) {
                response.container.find('.product-id').text(response.data.product.id);
                response.container.find('.size-extra-price').text(upChargeText);
            } else {
                $('.modal.show .product-quickview').data('pid', response.data.product.id);
                $('.modal.show .product-quickview').find('.size-extra-price').empty().append(upChargeText);
                $('.modal.show .full-pdp-link').attr('href', response.data.product.selectedProductUrl);
                $('.modal.show .product-quickview').find('.style').text('STYLE #' + response.data.product.id);
                $('.modal.show .product-quickview .primary-images').find('img').attr('src', response.data.product.images.quickView[0].url);
                $('.modal.show .product-quickview .zoom-hires').data('zoom-url', response.data.product.imagesZoom.pdpZoom[0].url);

                // Event rules defined on base.js
                if ($('#quickViewModal.show').length > 0) {
                    $(document.body).triggerHandler('globale:updatePrices');
                }
            }
            base.initSizeTooltips();
        });
    },
    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            $('button.add-to-cart', response.$productContainer).attr('disabled',
                (!response.product.readyToOrder || !response.product.available));

            // update global add to cart (single products, bundles)
            var dialog = $(response.$productContainer)
                .closest('.quick-view-dialog');

            $('.add-to-cart-global', dialog).attr('disabled',
                !$('.global-availability', dialog).data('ready-to-order')
                || !$('.global-availability', dialog).data('available')
            );
        });
    },

    shopMultiColorsSizesEvents: base.shopMultiColorsSizesEvents,

    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            // bundle individual products
            $('.product-availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available);

            var attrLength = response.product.variationAttributes.length;
            var hasSize = false;
            for (var i = 0; i < attrLength; i++) {
                var attr = response.product.variationAttributes[i].attributeId;
                if (attr === 'size') {
                    hasSize = true;
                }
            }
            if (response.product.availability.messagesTypes && response.product.availability.messagesTypes[0] !== 'restriction' && response.product.thresholdMessage.length > 0 && hasSize) {
                $('.product-threshold-message').empty().html(response.product.thresholdMessage).removeClass('d-none');
                $('.availability-msg').empty().addClass('d-none');
            } else {
                $('.availability-msg', response.$productContainer)
                    .empty().html(response.message).removeClass('d-none');
                $('.product-threshold-message').empty().addClass('d-none');
            }

            var dialog = $(response.$productContainer)
                .closest('.quick-view-dialog');

            if ($('.product-availability', dialog).length) {
                // bundle all products
                var allAvailable = $('.product-availability', dialog).toArray()
                    .every(function (item) { return $(item).data('available'); });

                var allReady = $('.product-availability', dialog).toArray()
                    .every(function (item) { return $(item).data('ready-to-order'); });

                $('.global-availability', dialog)
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg', dialog).empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            } else {
                // single product
                $('.global-availability', dialog)
                    .data('ready-to-order', response.product.readyToOrder)
                    .data('available', response.product.available)
                    .find('.availability-msg')
                    .empty()
                    .html(response.message);
            }
        });
    },
    quickViewZoom: function () {
        $('body').on('click', '.quick-view-dialog .slide.zoom-hires', function () {
            var isDesktop = utils.mediaBreakpointUp('md');
            var $imageBlock = $(this);
            if (isDesktop) {
                if ($imageBlock.hasClass('zoom-initialized')) {
                    $imageBlock.trigger('zoom.destroy');
                    $imageBlock.removeClass('zoom-initialized');
                    return;
                }

                var url = $imageBlock.data('zoom-url');
                if (url && url !== 'null') {
                    // Start spinner while zoom image loads
                    $imageBlock.spinner().start();

                    var config = {
                        url: url,
                        callback: function () {
                            // Stop spinner when zoom image loaded
                            $imageBlock.spinner().stop();
                            $imageBlock.addClass('zoom-initialized');
                        }
                    };
                    config = $.extend({}, zoomConfigs, config);

                    $imageBlock.zoom(config);
                }
            }
        });
    },
    switchLengthInQuickview: bindLengthSwitchInQuickview
};
